import {
  DriftskontraktAction,
  DriftskontraktModel,
} from "../Driftskontrakt/update"
import { GeneriskAction, GeneriskModel } from "../GeneriskeRapporter/update"
import React from "react"
import { ErrorData, UIAction } from "../../update/ui"
import { Just, Maybe, Nothing } from "purify-ts"
import { VegobjektType } from "../../utils/vegobjekt"
import { fetchVegobjectTyperTilvalg } from "../../data/api"
import { foldRemoteData } from "@nvdb-rapport/shared/src/utils/remoteData"
import Loading from "../Views/Loading"
import Autocomplete from "@material-ui/lab/Autocomplete"
import * as R from "remeda"
import { TextField } from "@material-ui/core"

function getObjectByName(
  objectName: string,
  allObjects: VegobjektType[]
): VegobjektType | undefined {
  return R.pipe(
    allObjects,
    R.find(o => o.navn === objectName)
  )
}

interface SingleObjectSelectionProps {
  state: DriftskontraktModel | GeneriskModel;
  dispatch:
    | React.Dispatch<DriftskontraktAction>
    | React.Dispatch<GeneriskAction>;
  uiDispatch: React.Dispatch<UIAction>;
  vegobjekt: Maybe<VegobjektType>;
  onSelect: (type: Maybe<VegobjektType>) => void;
  title?: string;
  filter?: string;
}

export default function SingleObjectSelection({
  state,
  dispatch,
  uiDispatch,
  vegobjekt,
  onSelect,
  title = "Velg enkeltobjekt",
  filter,
}: SingleObjectSelectionProps) {
  React.useEffect(() => {
    (async () => {
      dispatch({
        type: "SetVegobjektTilvalg",
        payload: { type: "LOADING" },
      })
      const objekttyperTilvalg = await fetchVegobjectTyperTilvalg(
        state.selectedReportType.caseOf({
          Nothing: () => {
            return -1
          },
          Just: area => {
            return area.id
          },
        })
      )

      objekttyperTilvalg.caseOf({
        Left: e => {
          const error: ErrorData = {
            message: e,
            title: "Feil ved innlasting av objekttyper",
          }
          dispatch({
            type: "SetVegobjektTilvalg",
            payload: {
              type: "FAILURE",
              error: error,
            },
          })
          uiDispatch({
            type: "AddError",
            payload: error,
          })
        },
        Right: data => {
          dispatch({
            type: "SetVegobjektTilvalg",
            payload: { type: "SUCCESS", data },
          })
        },
      })
    })()

    return () => {
      dispatch({
        type: "SetVegobjektTilvalg",
        payload: { type: "NOT_ASKED" },
      })
    }
  }, [])
  return (
    <div style={{ textAlign: "left" }}>
      <h3 style={{ fontSize: "1.2rem" }}>{title}</h3>
      <br />
      {foldRemoteData(
        state.vegobjektTilvalg,
        () => (
          <Loading />
        ),
        () => (
          <Loading />
        ),
        e => (
          <div>{e.message}</div>
        ),
        vegobjekter => (
          <Autocomplete
            options={R.pipe(
              vegobjekter,
              R.filter(objekt => objekt.navn !== filter),
              R.sortBy(objekt => objekt.navn),
              R.map(objekt => objekt.navn)
            )}
            multiple={false}
            value={vegobjekt.caseOf({
              Nothing: () => "",
              Just: object => object.navn,
            })}
            onChange={(_, inputValue) => {
              Maybe.fromNullable(inputValue).caseOf({
                Nothing: () => onSelect(Nothing),
                Just: value => {
                  const selectedObjekt = getObjectByName(value, vegobjekter)
                  if (selectedObjekt) {
                    onSelect(Just(selectedObjekt))
                  } else {
                    console.error("Finner ikke objekttype")
                  }
                },
              })
            }}
            freeSolo
            renderInput={params => (
              <TextField
                {...params}
                label={"Velg objekt"}
                variant="outlined"
                fullWidth
              />
            )}
          />
        )
      )}
    </div>
  )
}
